/**
 * Permission codes the notification screens declare an interest in.
 *
 * `notification.read` is the whole surface: `internal/notifications/handler.go`
 * puts the same code on all five routes, and its own comment explains why —
 * every route is scoped to the caller's own rows by `callerID(c)`, so listing,
 * marking read and deleting are not three authorities but one, "may this
 * account use the bell at all". There is deliberately no `notification.write`.
 *
 * The code already exists in the app-wide catalogue (`@/lib/permissions`), so
 * this re-exports rather than restating it: two literals for one server code is
 * one literal that can rot.
 */

import { PERMISSIONS } from '@/lib/permissions'

export const NOTIFICATIONS_PERMISSIONS = {
  read: PERMISSIONS.notificationRead,
} as const

export type NotificationsPermission =
  (typeof NOTIFICATIONS_PERMISSIONS)[keyof typeof NOTIFICATIONS_PERMISSIONS]
